
export default [
  {value: 0, label: '--'},
  {value: 1, label: 'CJ'},
  {value: 2, label: 'Linkshare'},
  {value: 3, label: 'GAN'},
  {value: 4, label: 'Amazon'},
  {value: 5, label: 'ShareASale'},
  {value: 6, label: 'Pepperjam'},
  {value: 7, label: 'Independent'},
  {value: 8, label: 'eBay'},
  {value: 9, label: 'AvantLink'},
  {value: 10, label: 'Digital River'},
  {value: 11, label: 'Affiliate Future'},
  {value: 12, label: 'Cleverbridge'},
  {value: 13, label: 'Impact Radius'},
  {value: 14, label: 'Linkconnector'},
  {value: 15, label: 'Webgains'},
  {value: 16, label: 'Affiliate Window'},

]
